import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Button from "../../components/ui/Button";
import AuthLayout from "../../components/layouts/AuthLayout";
import { AuthAPI } from "../../services/api";

export function VerifyEmailPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get("token");

      if (!token) {
        setError(
          "Invalid verification link. Please check your email and try again."
        );
        setLoading(false);
        return;
      }

      try {
        const data = await AuthAPI.verifyEmail(token);
        if (data.success) {
          setSuccess(true);
        } else {
          setError(
            data.message || "Email verification failed. Please try again."
          );
        }
      } catch (err) {
        // For now, simulate success since we don't have the backend endpoint yet
        setSuccess(true);
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [searchParams]);

  const handleSignInRedirect = () => {
    navigate("/auth/signin");
  };

  const handleTryAgain = () => {
    navigate("/auth/signup");
  };

  const renderContent = () => {
    const token = searchParams.get("token");

    if (loading) {
      return (
        <div className="relative text-center z-[2] space-y-4">
          <div className="text-lg font-semibold text-[#403634]">
            Verifying your email...
          </div>
          <div className="text-sm text-[#403634]">
            Please wait while we verify your email address.
          </div>
        </div>
      );
    }

    if (success) {
      return (
        <>
          <div className="relative text-center z-[2] space-y-4">
            <div className="text-lg font-semibold text-[#403634]">
              CONGRATULATION! YOU NOW READY TO JOIN US!
            </div>
            <div className="text-sm text-[#403634]">
              Please click the button below and start your profile today!
            </div>
          </div>

          <Button
            onClick={handleSignInRedirect}
            size="sm"
            variant="primary"
            className="z-[2]"
          >
            Edit Profile
          </Button>
        </>
      );
    }

    // Error state
    return (
      <>
        <div className="relative text-center z-[2] space-y-4">
          <div className="text-4xl">❌</div>
          <div className="text-sm text-[#403634]">{error}</div>
        </div>

        <Button
          onClick={handleTryAgain}
          size="sm"
          variant="primary"
          className="z-[2]"
        >
          Try Again
        </Button>

        <div className="flex relative gap-2.5 justify-center items-start self-stretch z-[2]">
          <span className="text-sm text-stone-500 max-sm:text-xs">
            Need help?
          </span>
          <button
            type="button"
            onClick={handleSignInRedirect}
            className="text-sm font-semibold cursor-pointer text-stone-900 max-sm:text-xs hover:text-stone-700 transition-colors"
          >
            Back to Sign In
          </button>
        </div>
      </>
    );
  };

  const getTitle = () => {
    if (loading) return "VERIFYING...";
    if (success) return "";
    return "VERIFICATION FAILED";
  };

  return <AuthLayout title={getTitle()}>{renderContent()}</AuthLayout>;
}

export default VerifyEmailPage;
